import { getComponent } from '../components/registry';
import { ComponentDef } from '../components/types';
import { GraphRenderer } from '../render/renderer';

function getDefaultParams(component: ComponentDef): Record<string, number | string> {
  const params: Record<string, number | string> = {};
  for (const param of component.params) {
    params[param.name] = param.default;
  }
  return params;
}

function createGraphStage(title: string, component: ComponentDef): HTMLElement {
  const section = document.createElement('section');
  section.className = 'compare-section';

  const heading = document.createElement('h2');
  heading.textContent = title;
  section.appendChild(heading);

  const desc = document.createElement('p');
  desc.className = 'description';
  desc.textContent = component.description;
  section.appendChild(desc);

  const stage = document.createElement('div');
  stage.className = 'graph-stage';

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('class', 'graph-svg');
  stage.appendChild(svg);
  section.appendChild(stage);

  requestAnimationFrame(() => {
    const renderer = new GraphRenderer(svg);
    renderer.render(component.buildGraph(getDefaultParams(component)));
  });

  return section;
}

export function renderCompareView(
  container: HTMLElement,
  idA: string,
  idB: string
): void {
  const a = getComponent(idA);
  const b = getComponent(idB);

  if (!a || !b) {
    container.innerHTML = `
      <div class="not-found">
        <h1>Compare not found</h1>
        <p>${!a ? `Component A (${idA})` : `Component B (${idB})`} does not exist.</p>
        <a href="#/">Back home</a>
      </div>
    `;
    return;
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'compare-view';

  const header = document.createElement('header');
  header.className = 'compare-header';
  header.innerHTML = `<h1>Compare: ${a.name} vs ${b.name}</h1>`;
  wrapper.appendChild(header);

  const grid = document.createElement('div');
  grid.className = 'compare-grid';
  grid.appendChild(createGraphStage(a.name, a));
  grid.appendChild(createGraphStage(b.name, b));
  wrapper.appendChild(grid);

  container.appendChild(wrapper);
}
